import { render, staticRenderFns } from "./permissionRole.vue?vue&type=template&id=fa961474&scoped=true&"
import script from "./permissionRole.vue?vue&type=script&lang=js&"
export * from "./permissionRole.vue?vue&type=script&lang=js&"
import style0 from "./permissionRole.vue?vue&type=style&index=0&id=fa961474&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa961474",
  null
  
)

component.options.__file = "permissionRole.vue"
export default component.exports